import React, { useEffect, useState } from "react";

const Card = (dataprops) => {
  const [modal, setModal] = useState(false);
  const props = dataprops.data;

  const toggleModal = () => {
    setModal(!modal);
  };

  useEffect(() => {
    if (modal) {
      document.body.classList.add("active-modal");
    } else {
      document.body.classList.remove("active-modal");
    }

    return () => {
      document.body.classList.remove("active-modal");
    };
  }, [modal]);

  return (
    <div>
      <div className="box btn_shadow " onClick={toggleModal}>
        <div className="img">
          <img src={props.image} alt={props.title} />
        </div>

        <div className="title  d_flex">
          <h2>{props.title}</h2>
          <label>
            <i className="far fa-heart"></i> {props.totalLike}
          </label>
        </div>

        <div className="category">
          <span>{props.subtitle}</span>
          <a href="#popup" className="arrow">
            <i class="fas fa-arrow-right"></i>
          </a>
        </div>
      </div>

      {/* Popup box */}
      {modal && (
        <div className="modal">
          <div onClick={toggleModal} className="overlay"></div>
          <div className="modal-content d_flex">
            <div className="modal-img left">
              <img src={props.image} alt={props.title} />
            </div>

            <div className="modal-text right">
              <div className="project-details">
                <h1>{props.title}</h1>
                <p>{props.description}</p>
                <h4>Technologies Used:</h4>
                <ul className="tech">
                  {props.technologies.map((tech, index) => (
                    <li key={index}>
                      {tech} <span> | </span>
                    </li>
                  ))}
                </ul>

                <h4>Key Features:</h4>
                <ul>
                  {props.features.map((feature, index) => (
                    <li key={index}>- {feature}</li>
                  ))}
                </ul>
              </div>

              <div className="button f_flex">
                <button className="btn_shadow">
                  LIKE THIS <i class="far fa-thumbs-up"></i>
                </button>

                <a href={props.view} target="_blank" rel="noopener noreferrer">
                  <button className="btn_shadow">
                    VIEW PROJECT <i className="fas fa-chevron-right"></i>
                  </button>
                </a>
              </div>

              <button className="close-modal btn_shadow" onClick={toggleModal}>
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Card;
